import { Component, OnInit, Input, forwardRef} from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, ReactiveFormsModule, NG_VALUE_ACCESSOR, Validators, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import {JsonPipe, CommonModule } from '@angular/common';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import {default as _rollupMoment} from 'moment';
import { MAT_DATE_LOCALE } from '@angular/material/core';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-range-box',
  templateUrl: 'date-range-box.component.html',
  styleUrls: ['./date-range-box.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeBoxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateRangeBoxComponent),
      multi: true,
    },
    provideMomentDateAdapter(MY_FORMATS),
    [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
  ],
  imports: [MatFormFieldModule, MatDatepickerModule, JsonPipe, ReactiveFormsModule, CommonModule],
})

export class DateRangeBoxComponent implements OnInit, ControlValueAccessor {
  
  @Input() label: string;
  @Input() required: boolean;
  @Input() formControlNameInit: string;
  @Input() formControlNameEnd: string;
  @Input() frm: FormGroup;

  modelo: any;

  ngOnInit(): void {

    //const controlInit = new FormControl(moment());
    const controlInit = this.frm.get(this.formControlNameInit) as FormControl;
    //const controlEnd = new FormControl(moment());
    const controlEnd = this.frm.get(this.formControlNameEnd) as FormControl;

    if (controlInit) {
      const validators: ValidatorFn[] = [];

      // Agregar el validador requerido si es necesario
      if (this.required) {
        validators.push(Validators.required);
      }

      // Asignar validadores solo si hay validadores
      if (validators.length > 0) {
        controlInit.setValidators(validators);
        controlInit.updateValueAndValidity(); // Actualizar el control con los nuevos validadores
      }
    }

    if (controlEnd) {
      const validators: ValidatorFn[] = [];

      // Agregar el validador requerido si es necesario
      if (this.required) {
        validators.push(Validators.required);
      }

      // Asignar validadores solo si hay validadores
      if (validators.length > 0) {
        controlEnd.setValidators(validators);
        controlEnd.updateValueAndValidity(); // Actualizar el control con los nuevos validadores
      }
    }

  }

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this.modelo;
  }

  set value(val) {
    this.modelo = val;
    this.onChange(val);
    this.onTouched();
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  get ctrlInvalid() {
    return this.frm.controls[this.formControlNameInit].invalid || this.frm.controls[this.formControlNameEnd].invalid;
  }
  
  get ctrlTouched() {
    return this.frm.controls[this.formControlNameInit].touched || this.frm.controls[this.formControlNameEnd].touched;
  }

  validate(control: AbstractControl): { [key: string]: any } | null {

    return null;
  }


}